import { render, staticRenderFns } from "./PermissionsManagement.vue?vue&type=template&id=7e7a608a&"
import script from "./PermissionsManagement.vue?vue&type=script&lang=js&"
export * from "./PermissionsManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QBreadcrumbs,QBreadcrumbsEl,QBtn,QCard,QCardSection,QSeparator} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QBreadcrumbs,QBreadcrumbsEl,QBtn,QCard,QCardSection,QSeparator})
